import { purify } from "../../_src/components/purify";

export function searchAndloadMoreArticles() {
    var btnLoadMore = document.querySelector("[data-action=load-more-publications]")
    const form = document.querySelector('#filter-publications');

    if (!btnLoadMore) {
        return;
    }

    function loadMore(loadMore) {
        const data = form ? new FormData(form) : new FormData();

        var customClass = btnLoadMore.dataset.customClass; 
        data.append('customClass', customClass);

        btnLoadMore.classList.add("loading")

        if (!loadMore) {
            document.querySelector("#result-publications-collection").innerHTML = "";
            document.querySelector(".loader-publications").classList.remove("hidden")
        }

        document.querySelectorAll("#filter-publications fieldset").forEach(function (el) {
            el.classList.add("disabled")
        })

        fetch(`/acervo-digital/publicacoes/ajax/publications/p${btnLoadMore.getAttribute("data-page")}?&loadmore=${loadMore}`, {
            method: "POST",
            body: data
        }).then((response) => {
            return response.text();
        }).then((response) => {
            console.log(response)
            if (loadMore) {
                document.querySelector("#result-publications-collection").insertAdjacentHTML('beforeend', response);
            } else {
                document.querySelector("#result-publications-collection").innerHTML = purify(response)
                searchAndloadMoreArticles();
            }

        })
        .catch((error) => {
            console.error(error);
        })
        .finally(() => {

            btnLoadMore.classList.remove("loading")

            if (!loadMore) {
                document.querySelector(".loader-publications").classList.add("hidden")
            }

            if (parseInt(btnLoadMore.getAttribute("data-page")) > parseInt(btnLoadMore.getAttribute("data-total"))) {
                btnLoadMore.remove()
            }

            document.querySelectorAll("#filter-publications fieldset").forEach(function (el) {
                el.classList.remove("disabled")
            })

        });
    }


    btnLoadMore.addEventListener("click", function () { loadMore(true), btnLoadMore.dataset.page = parseInt(btnLoadMore.dataset.page) + 1 }, false);

    if (form) {
        document.querySelector("#filter-publications").addEventListener("change", function (event) { event.preventDefault(), setTimeout(() => { loadMore(false) }, 100), btnLoadMore.dataset.page = "1" }, false);
    }
}

if (document.querySelector("#filter-publications")) {
    searchAndloadMoreArticles();
}
